import { Common } from './common';
import {
  CreateValues,
  UpdateValues,
  FindAllOptions,
  RecommendationTemplate,
  RecommendationTemplatePopulated,
} from './models/recommendationTemplate';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    options: FindAllOptions = {},
  ): Promise<RecommendationTemplatePopulated[]> {
    const url = this.common.constructPath(
      `/recommendation-templates/`,
      options,
    );
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<RecommendationTemplate> {
    const url = this.common.constructPath(`/recommendation-templates/${id}`);
    return this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<RecommendationTemplate> {
    const url = this.common.constructPath(`/recommendation-templates/`);
    return this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: UpdateValues,
  ): Promise<RecommendationTemplate> {
    const url = this.common.constructPath(`/recommendation-templates/${id}`);
    return this.common.patchJSON(url, values);
  }

  async delete(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/recommendation-templates/${id}`);
    return this.common.deleteJSON(url);
  }
}
